import styled from "styled-components";

export const Source = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  border-right: 1px solid ${({ theme }) => theme.colors.spiderSilk.bgColor};
`;
